import { useNextUpIncident } from '../hooks/useNextUpIncident'

import { Button } from '@/components/ui'

interface IProps {
  isActive: boolean
}

export const NextUpButton = ({ isActive }: IProps) => {
  const { label, isDisabled, isLoading, onPress } = useNextUpIncident({
    isEnabled: isActive,
  })

  if (!isActive) return null

  return (
    <Button
      data-testid='incidentsPage_tableHeader_nextUpButton'
      fontSize='12px'
      fontWeight='500'
      h='40px'
      isDisabled={isDisabled}
      isLoading={isLoading}
      onClick={onPress}
      rounded='6px'
      variant='secondary'
    >
      {label}
    </Button>
  )
}
